export default __webpack_public_path__ + "static/640-645-e14ac1de221b89c8d31a6628a0227431.jpg";